import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const WorkOrderService = {
    async getByCode(code) {
        const requestScreenData = {
            url: "api/WorkOrder",
            top: "1",
            filter: `Code eq ${code}`,
            select: 'Code,QuoteCode,BomCode,ShipDate,ScheduledDate,ItemQty,DivisionCode,BranchCode,Comment,ProductCode,CreatedBy,DateCreated,ChangedBy,DateChanged,FriendlyStatus,MTSQuantity,SalesOrderStockUMQuantity'
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async save(payload) {
        const url = "api/Save_WorkOrder";

        return await ApiService.post(url, payload);
    },

    async completeWorkOrder(payload) {

        const url = "api/WorkOrder/Complete";

        return await ApiService.post(url, payload);
    },

    async reopenWorkOrder(payload) {

        const url = "api/WorkOrder/ReOpen";

        return await ApiService.post(url, payload);
    },

    async cancelWorkOrder(payload) {

        const url = "api/WorkOrder/Cancel";

        return await ApiService.post(url, payload);
    },

    async workOrderReschedule(payload) {
        const url = "api/Save_WorkOrderReschedule";

        return await ApiService.post(url, payload);
    },

    async getWOSOLines(WOCode) {

        const requestScreenData = {
            url: "api/WorkOrderToSalesOrderLineList",
            filter: `WorkOrderCode eq ${WOCode}`,
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async getBOMByCode(code) {
        const requestScreenData = {
            url: "api/Bom",
            top: "1",
            filter: `Code eq '${code}'`,
            select: 'Code,Comment,Description1,Description2,ProductCode,BatchSize,BranchCode,DivisionCode,BomTypeCode,Status'
        };

        return await ApiService.oDataGet(requestScreenData);
    },

}

export { WorkOrderService };